export const LS_ACK_KEY = 'tg-eval-anomaly-acks-v1';
export const LS_NOTE_KEY = 'tg-eval-anomaly-notes-v1';

export function loadAcks(storage: Storage = localStorage): Set<number> {
  try {
    const parsed: unknown = JSON.parse(storage.getItem(LS_ACK_KEY) || '[]');
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((value): value is number => typeof value === 'number'));
  } catch {
    return new Set();
  }
}

export function saveAcks(set: Set<number>, storage: Storage = localStorage): void {
  try {
    storage.setItem(LS_ACK_KEY, JSON.stringify(Array.from(set)));
  } catch {
    // localStorage can be unavailable in private or restricted contexts.
  }
}

export function loadNotes(storage: Storage = localStorage): Record<number, string> {
  try {
    const parsed: unknown = JSON.parse(storage.getItem(LS_NOTE_KEY) || '{}');
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    return Object.fromEntries(
      Object.entries(parsed).filter((entry): entry is [string, string] => {
        const [, value] = entry;
        return typeof value === 'string';
      }),
    );
  } catch {
    return {};
  }
}

export function saveNotes(notes: Record<number, string>, storage: Storage = localStorage): void {
  try {
    storage.setItem(LS_NOTE_KEY, JSON.stringify(notes));
  } catch {
    // localStorage can be unavailable in private or restricted contexts.
  }
}
